import clsx from 'clsx';
import { TFunction, Trans } from 'next-i18next/pages';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface SectionTitleProps {
  className?: string;
  id?: string;
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  mainColor?: string;
  noMargin?: boolean;
  t?: TFunction;
  titleKey: string;
}

export const SectionTitleBase: React.FC<SectionTitleProps> = ({
  className,
  id,
  level = 'h4',
  mainColor = 'text-primary',
  t,
  titleKey,
  noMargin,
}) => {
  const Heading = level;
  return (
    <Heading className={twMerge(clsx(`text-md text-default font-bold md:text-2xl`, !noMargin && 'mb-2 md:mb-6', className))} id={id}>
      <Trans
        components={{
          span: <span className={clsx('font-handwriting text-2xl font-normal md:text-3xl', mainColor)} />,
        }}
        i18nKey={titleKey}
        t={t}
      />
    </Heading>
  );
};
